import React, { Component } from 'react';
import Row from './Row';

export default class Grid extends Component {
  render() {
    const { grid } = this.props;
    return <div className={`${this.props.className} Grid`}>
      { grid.map((value, i) => <Row key={`row-${i}`} value={value} set={v => this.props.set(i, v)} />) }
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/Grid.js